import { reatomAsync, withDataAtom } from "@reatom/async";
import { PageableRequestDto } from "definitions/poizon-sso";
import { API } from "src/api";

export const getAccessRights = reatomAsync(
  async (ctx, data: PageableRequestDto) => {
    return API.accessRightApi
      .accessRightControllerGetAllAccessRights(data)
      .then((response) => response.data);
  },
  "getAccessRightsRequest",
).pipe(withDataAtom({ data: [], totalItems: 0 }));
